import { Component, inject } from '@angular/core';
import { BaseComponent } from "@wms/components";
import { BindWidgetsVariablesUtilsService } from "@wms/app/services/bind-widgets-variables-utils/bind-widgets-variables-utils.service";
import { FormsModule } from "@angular/forms";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'wms-page-select',
  templateUrl: './page-select.component.html',
  styleUrls: ['./page-select.component.less'],
  standalone: true,
  imports: [
    FormsModule,
    NgForOf
  ]
})
export class PageSelectComponent extends BaseComponent {
  bindWidgetsVariablesUtilsService = inject(BindWidgetsVariablesUtilsService);
}
